/**
 * Hero section with main headline and CTA
 */
function Hero() {
	return (
		<section className="hero">
			<div className="hero-content">
				<h1 className="hero-title">
					Building the Future with <span className="gradient-text">Web3</span> & <span className="gradient-text">AI</span>
				</h1>
				<p className="hero-subtitle">
					We design and develop cutting-edge decentralized applications and intelligent systems 
					that transform how businesses operate in the digital economy.
				</p>
				<div className="hero-cta">
					<a href="mailto:hello@3oh.io" className="btn btn-primary">Get in Touch</a>
					<a href="#services" className="btn btn-secondary">Our Services</a>
				</div>
			</div>
			<div className="hero-visual">
				<div className="hero-glow" />
			</div>
		</section>
	);
}

export default Hero;
